import { render, staticRenderFns } from "./LegacyServerHostingService.vue?vue&type=template&id=05b893ca&"
import script from "./LegacyServerHostingService.vue?vue&type=script&lang=js&"
export * from "./LegacyServerHostingService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports